import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { load as loadLabel, loadObject, loadProject, filterProject, filterObject } from '../../../reducers/models/label/labelList'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArchive, faDiagramProject, faExpand, faFilter, faPlay } from "@fortawesome/free-solid-svg-icons";
import Modal from "./LabelModal";
import TabBar from "../../../components/ui/TabBar";
import List from "./List";
import InfoNoData from "../../../components/global/InfoNoData";
import FilterUniversal from "../../../components/filter/FilterUniversal";
import axios from "axios";
import ModalAdd from "../../../components/modal/ModalAdd";
import ErrorAdd from "../../../util/ErrorAdd";

function Index() {

    const dispatch = useDispatch()

    //TAB START
    const [tab, setTab] = useState([
        { id_tab: 1, name: "Активные", icon: faPlay, showCount: false, loading: false, loading1: false, loading2: false }
        , { id_tab: 0, name: "Архив", icon: faArchive, showCount: false, loading: false, loading1: false, loading2: false }
    ]);

    const [filterShow, setFilterShow] = useState(false);
    const [tabSelected, setTabSelected] = useState(1);
    //TAB END

    const stateLabelList = useSelector((state) => state.labelList);

    useEffect(() => {
        if (stateLabelList.listLoaded.filter(a => a.id_tab === 1).length === 0) {
            loadList(1);
        }
    }, []);

    const [log, setLog] = useState(null);
    const [loading, setLoading] = useState(false);

    const [model, setModel] = useState(false);

    const [modalEditShow, setModalEditShow] = useState(false);

    useEffect(() => {
        if (tab.filter(a => a.id_tab === tabSelected & a.loading1 === false & a.loading2 === false & a.loading === true).length > 0) {
            setTab(tab_ => tab_.map(item => {
                if (item.id_tab === tabSelected) {
                    return { ...item, loading: false }
                }
                else {
                    return item;
                }
            }))
        }
    }, [tab, tabSelected]);

    function loadList(id_status) {

        setTab(tab_ => tab_.map(item => {
            if (item.id_tab === id_status) {
                return { ...item, loading: true, loading1: true, loading2: true }
            }
            else {
                return item;
            }
        }))

        axios.get('/api_tracker/label/list', { params: { ID_Status: id_status } })
            .then((res) => {
                if (res.data.Status === 1) {

                    dispatch(loadLabel({ list: res.data.Data, id_tab: id_status }));

                    axios.get('/api_tracker/label/objectList', { params: { ID_Status: id_status } })
                        .then((res1) => {
                            if (res1.data.Status == 1) {
                                if (res1.data.Status == 1) {
                                    dispatch(loadObject({ list: res1.data.Data, id_tab: id_status }))
                                }
                                else {
                                    setLog(res1.data.Error);
                                }

                                setTab(tab_ => tab_.map(item => {
                                    if (item.id_tab === id_status) {
                                        return { ...item, loading1: false }
                                    }
                                    else {
                                        return item;
                                    }
                                }))
                            }
                            else {
                                setLog(res.data.Error);

                                setTab(tab_ => tab_.map(item => {
                                    if (item.id_tab === id_status) {
                                        return { ...item, loading1: false }
                                    }
                                    else {
                                        return item;
                                    }
                                }))
                            }
                        })
                        .catch((err) => {
                            setLog('Неизвестная ошибка!');

                            setTab(tab_ => tab_.map(item => {
                                if (item.id_tab === id_status) {
                                    return { ...item, loading1: false }
                                }
                                else {
                                    return item;
                                }
                            }))

                            ErrorAdd(err, window.location.href);
                        })

                    axios.get('/api_tracker/label/projectList', { params: { ID_Status: id_status } })
                        .then((res2) => {
                            if (res2.data.Status == 1) {
                                if (res2.data.Status == 1) {
                                    dispatch(loadProject({ list: res2.data.Data, id_tab: id_status }))
                                }
                                else {
                                    setLog(res2.data.Error);
                                }
                                setTab(tab_ => tab_.map(item => {
                                    if (item.id_tab === id_status) {
                                        return { ...item, loading2: false }
                                    }
                                    else {
                                        return item;
                                    }
                                }))
                            }
                            else {
                                setLog(res.Error);
                                setTab(tab_ => tab_.map(item => {
                                    if (item.id_tab === id_status) {
                                        return { ...item, loading1: false }
                                    }
                                    else {
                                        return item;
                                    }
                                }))
                            }
                        })
                        .catch((err) => {
                            setLog('Неизвестная ошибка!');
                            setTab(tab_ => tab_.map(item => {
                                if (item.id_tab === id_status) {
                                    return { ...item, loading1: false }
                                }
                                else {
                                    return item;
                                }
                            }))
                            ErrorAdd(err, window.location.href);
                        })

                }
                else {
                    setLog(res.Error);
                    setTab(tab_ => tab_.map(item => {
                        if (item.id_tab === id_status) {
                            return { ...item, loading: false, loading1: false, loading2: false }
                        }
                        else {
                            return item;
                        }
                    }))
                }
            })
            .catch((err) => {
                setLog('Неизвестная ошибка!');
                setTab(tab_ => tab_.map(item => {
                    if (item.id_tab === id_status) {
                        return { ...item, loading: false, loading1: false, loading2: false }
                    }
                    else {
                        return item;
                    }
                }))

                ErrorAdd(err, window.location.href);
            })
    }
    function tabHandler(id_tab) {
        setTabSelected(id_tab)

        if (id_tab === 0) {
            if (stateLabelList.listLoaded.filter(a => a.id_tab === 0).length === 0) {
                loadList(0);
            }
        }
    }
    function editHandler(model) {
        setModel(model);
        setModalEditShow(true);
    }

    /**********************START ФИЛЬТР ПРОЕКТОВ*******************************/
    const [filterProjectList, setFilterProjectList] = useState([]);
    const [filterProjectSelected, setFilterProjectSelected] = useState([{ id_tab: 0, val: -1 }, { id_tab: 1, val: -1 }]);

    useEffect(() => {
        /*
            id - ИД проекта
            name - Название проекта
            count - Кол-во элементов в проекте 
        */
        var data = [
            { id: -1, name: 'Все метки', count: stateLabelList.list.filter(a => a.id_tab === 0).length, id_tab: 0 },
            { id: -1, name: 'Все метки', count: stateLabelList.list.filter(a => a.id_tab === 1).length, id_tab: 1 },
            { id: 0, name: 'Все проекты', count: stateLabelList.list.filter(a => a.id_tab === 0 & a.All_Project === true).length, id_tab: 0 },
            { id: 0, name: 'Все проекты', count: stateLabelList.list.filter(a => a.id_tab === 1 & a.All_Project === true).length, id_tab: 1 }
        ];

        stateLabelList.listProject.map((item) => {
            if (data.filter(a => a.id === item.ID_Project & a.id_tab === item.id_tab).length === 0) {
                data.push(
                    {
                        id: item.ID_Project,
                        name: item.Name_Project,
                        count: stateLabelList.listProject.filter(a => a.ID_Project === item.ID_Project).length,
                        id_tab: item.id_tab
                    }
                )
            }
        })
        setFilterProjectList(data);

    }, [stateLabelList.listProject]);

    function filterProjectHandler(id_project, id_tab) {

        const val_ = filterProjectSelected.filter(a => a.id_tab === id_tab)[0].val === id_project ? -1 : id_project;

        const list = filterProjectSelected.map(item => {
            if (item.id_tab === id_tab) {
                return { ...item, val: val_ }
            }
            else {
                return { ...item }
            }
        })

        dispatch(filterProject({ id_tab: id_tab, id_project: val_ }));
        setFilterProjectSelected(list);
    }
    /***********************END ФИЛЬТР ПРОЕКТОВ********************************/
    /**********************START ФИЛЬТР ОБЪЕКТОВ*******************************/
    const [filterObjectList, setFilterObjectList] = useState([]);
    const [filterObjectSelected, setFilterObjectSelected] = useState([{ id_tab: 0, val: -1 }, { id_tab: 1, val: -1 }]);

    useEffect(() => {
        /*
            id - ИД проекта
            name - Название проекта
            count - Кол-во элементов в проекте 
        */
        var data = [
            { id: -1, name: 'Все метки', count: stateLabelList.list.filter(a => a.id_tab === 0).length, id_tab: 0 },
            { id: -1, name: 'Все метки', count: stateLabelList.list.filter(a => a.id_tab === 1).length, id_tab: 1 },
            { id: 0, name: 'Все объекты', count: stateLabelList.list.filter(a => a.id_tab === 0 & a.All_Object === true).length, id_tab: 0 },
            { id: 0, name: 'Все объекты', count: stateLabelList.list.filter(a => a.id_tab === 1 & a.All_Object === true).length, id_tab: 1 }
        ];
        stateLabelList.listObject.map((item) => {
            if (data.filter(a => a.id === item.ID_Object & a.id_tab === item.id_tab).length === 0) {
                data.push(
                    {
                        id: item.ID_Object,
                        name: item.Name_Object,
                        count: stateLabelList.listObject.filter(a => a.ID_Object === item.ID_Object).length,
                        id_tab: item.id_tab
                    }
                )
            }
        })
        setFilterObjectList(data);

    }, [stateLabelList.listObject]);

    function filterObjectHandler(id_object, id_tab) {

        const val_ = filterObjectSelected.filter(a => a.id_tab === id_tab)[0].val === id_object ? -1 : id_object;

        const list = filterObjectSelected.map(item => {
            if (item.id_tab === id_tab) {
                return { ...item, val: val_ }
            }
            else {
                return { ...item }
            }
        })

        dispatch(filterObject({ id_tab: id_tab, id_object: val_ }));
        setFilterObjectSelected(list);
    }
    /***********************END ФИЛЬТР ОБЪЕКТОВ********************************/
    /*********************START ДОБАВЛЕНИЕ МЕТКИ*******************************/
    const [modalAddShow, setModalAddShow] = useState(false);
    const [addLoading, setAddLoading] = useState(false);
    const [addLog, setAddLog] = useState(null);

    function addHandler(name) {
        setAddLoading(true);
        setAddLog(null);

        if (name === null) {
            setAddLog('Введите название метки');
            setAddLoading(false);
        }
        else {
            axios.post('/api_tracker/label/add', { Name: name, All_Object: true, All_Project: true, Color: '#dddfe0' })
                .then((res) => {
                    if (res.data.Status === 1) {
                        //setAddLoading(false);
                        //setModalAddShow(false);
                        //onHide();
                        getNew(res.data.Data);
                    }
                    else {
                        setAddLoading(false);
                        setAddLog(res.data.Error);
                    }
                })
                .catch((err) => {
                    setAddLog('Неизвестная ошибка!');
                    setAddLoading(false);
                    ErrorAdd(err, window.location.href);
                });
        }
    }

    function getNew(id) {
        axios.get('/api_tracker/label/get', { params: { ID: id } })
            .then((res) => {
                if (res.data.Status == 1) {
                    setModel(res.data.Data);
                    setModalAddShow(false);
                    setModalEditShow(true);
                    setAddLoading(false);
                }
                else {
                    setAddLoading(false);
                    setAddLog(res.Error);
                }
            })
            .catch((err) => {
                setAddLog('Неизвестная ошибка!');
                setAddLoading(false);
                ErrorAdd(err, window.location.href);
            });
    }
    /**********************END ДОБАВЛЕНИЕ МЕТКИ********************************/
    return (
        <div className='admin_content'>
            {modalAddShow === true && (
                <ModalAdd show={modalAddShow} onHide={() => setModalAddShow(false)} title='Добавление метки' loading={addLoading} error={addLog} updateHandler={addHandler} />
            )}
            {modalEditShow === true && stateLabelList.list.filter(a => a.ID === model.ID).length > 0 && (
                <Modal show={modalEditShow} onHide={() => setModalEditShow(false)} edit={true} model={stateLabelList.list.filter(a => a.ID === model.ID)[0]} />
            )}
            <div className="mb-20">
                <TabBar tabData={tab} tabSelected={tabSelected} tabClikHandler={tabHandler} filterShow={filterShow} setFilterShow={setFilterShow} showAdd={true} setAddShow={setModalAddShow} showFilter={true} />
            </div>
            {tab.map(tab => (
                <div key={tab.id_tab} className={tab.id_tab !== tabSelected ? "d-none" : ""}>
                    <div className={filterShow === false ? "d-none" : ""}>
                        <div className="filter-container">
                            <div className="filter-title"><FontAwesomeIcon icon={faFilter} />ФИЛЬТР</div>
                            <FilterUniversal filterName='Проекты' filterIcon={faDiagramProject} list={filterProjectList.filter(a => a.id_tab === tab.id_tab)} id_filter={tab.id_tab} clickHandler={filterProjectHandler} selected={filterProjectSelected.filter(a => a.id_tab === tab.id_tab)[0].val} show_count={true} />
                            <FilterUniversal filterName='Объекты' filterIcon={faExpand} list={filterObjectList.filter(a => a.id_tab === tab.id_tab)} id_filter={tab.id_tab} clickHandler={filterObjectHandler} selected={filterObjectSelected.filter(a => a.id_tab === tab.id_tab)[0].val} show_count={true} />
                        </div>
                    </div>
                    <div className="mt-20">
                        {tab.loading === true ? (
                            <div className="loader_01 mt-30"></div>
                        )
                            :
                            (
                                stateLabelList.list.filter(a => a.id_tab === tab.id_tab).length === 0 ? (
                                    <InfoNoData text="Нет меток" />
                                ) : (
                                    <List key={0}
                                        editHandler={editHandler}
                                        list={stateLabelList.list.filter(a => a.id_tab === tab.id_tab & a.filter_project === false & a.filter_object === false)}
                                        idTab={tab.id_tab}
                                    />
                                )
                            )
                        }
                    </div>
                </div>
            ))}
        </div>
    )
}
export default Index;